/***
 * Summary: here resides the scheme and roles for the fields of the network performing
 * 
 */
import { yupToFormErrors } from "formik";
import * as Yup from "yup";

const createNumberValidation = (fieldName) =>
  Yup.number()
    .typeError(`Invalid data. '${fieldName}' must be a number`)
    .nullable(true)
    .test('is-number', `Invalid data. '${fieldName}' must be a number`, function (value) {
      return (value == null || value == undefined || !isNaN(value)) || this.createError({ message: `Invalid data. '${fieldName}' must be a number` });
    });

const TODIS_NP_SCHEMA = Yup.object().shape({
  //general section Rules:
  // general_road_id: Yup.string("Road ID is alphanumeric"),
  startKm: Yup.number()
    .typeError("Invalid data. 'Start km' must be a 'number'")
    .nullable(true)
    .test('is-number', 'Invalid data. \'Start km\' must be a number', function (value) {
      if (isNaN(value) && value != null && value != undefined && value != '') {
        throw this.createError({ message: 'Invalid data. \'Start km\' must be a number' });
      }
      return true;
    }),
  endKm: Yup.number()
    .typeError("Invalid data. 'End km' must be a 'number'")
    .nullable(true)
    .test('is-number', 'Invalid data. \'End km\' must be a number', function (value) {
      if (isNaN(value) && value != null && value != undefined && value != '') {
        throw this.createError({ message: 'Invalid data. \'End km\' must be a number' });
      }
      return true;
    }),
  /*   dateValidTo: Yup.date("Valid from is a Date").required("Date to, is required").nullable(true),
    dateValidFrom: Yup.date("Valid to is a Date").required("Date from, is required").nullable(true), */
  dateValidFor: Yup.string("Valid for is a Year"),
  tenTCategory: Yup.string("tent category is alphanumeric").nullable(true),
  routeId: Yup.string("Route ID is alphanumeric").nullable(true),
  nationalRouteId: Yup.string("National Route ID is alphanumeric").nullable(true),
  internationalRouteId: Yup.string("International Route ID is alphanumeric").nullable(true),
  startNodeName: Yup.string("Start Node Name ID is alphanumeric").nullable(true),
  endNodeName: Yup.string("End Node Name is alphanumeric").nullable(true),
  nameResp: Yup.string("Road ID is alphanumeric").nullable(true),
  addressResp: Yup.string("Road ID is alphanumeric").nullable(true),
  contactPer: Yup.string("Road ID is alphanumeric").nullable(true),
  contactPos: Yup.string("Road ID is alphanumeric").nullable(true),
  contactNum: Yup.string()
    .transform((originalValue) => {
      // Si el valor comienza con '+', eliminamos ese símbolo
      return typeof originalValue == 'string' ? originalValue.replace(/^\+/, '') : originalValue;
    })
    .nullable(true)
    .test('is-valid', 'Invalid data. \'Phone Number\' must be a valid number', function (value) {
      // Permitir números, espacios, y la presencia de '+'
      const isValid = /^[0-9+\s]+$/.test(value) || value == null;

      if (!isValid) {
        throw this.createError({ message: 'Invalid data. \'Phone Number\' must be a valid number' });
      }

      return true;
    }),


  contactEmail: Yup.string("Email")
    .transform((originalValue) => {
      // Realizar transformaciones si es necesario
      return typeof originalValue == 'string' ? originalValue.trim() : originalValue;
    })
    .nullable(true)
    .test('is-email', 'Invalid data. \'Email\' must be valid', function (value) {
      // Si el valor es null o undefined, lo consideramos válido y no aplicamos más validaciones
      if (value == null || value == undefined) {
        return true;
      }

      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

      // Verificar si es una cadena antes de intentar dividirla
      if (typeof value == 'string') {
        const emails = value.split(/[,;:]+/);  // Separar por comas, punto y coma, o dos puntos

        for (const email of emails) {
          if (!emailRegex.test(email.trim())) {
            throw this.createError({ message: `Invalid data. '${email}' must be a valid email address` });
          }
        }
      }

      return true;
    }),
  regionalPartner: Yup.string("regional Partner").nullable(true),
  startKmDirA: Yup.number()
    .typeError("Invalid data. 'Start km (Direction A)' must be a 'number'")
    .nullable(true)
    .test('is-number', 'Invalid data. \'Start km (Direction A)\' must be a number', function (value) {
      if (isNaN(value) && value != null && value != undefined && value != '') {
        throw this.createError({ message: 'Invalid data. \'Start km (Direction A)\' must be a number' });
      }
      return true;
    }),
  startKmDirB: Yup.number()
    .typeError("Invalid data. 'Start km (Direction B)' must be a 'number'")
    .nullable(true)
    .test('is-number', 'Invalid data. \'Start km (Direction B)\' must be a number', function (value) {
      if (isNaN(value) && value != null && value != undefined && value != '') {
        throw this.createError({ message: 'Invalid data. \'Start km (Direction B)\' must be a number' });
      }
      return true;
    }),
  endKmDirA: Yup.number()
    .typeError("Invalid data. 'End km (Direction A)' must be a 'number'")
    .nullable(true)
    .test('is-number', 'Invalid data. \'End km (Direction A)\' must be a number', function (value) {
      if (isNaN(value) && value != null && value != undefined && value != '') {
        throw this.createError({ message: 'Invalid data. \'End km (Direction A)\' must be a number' });
      }
      return true;
    }),
  endKmDirB: Yup.number()
    .typeError("Invalid data. 'End km (Direction B)' must be a 'number'")
    .nullable(true)
    .test('is-number', 'Invalid data. \'End km (Direction B)\' must be a number', function (value) {
      if (isNaN(value) && value != null && value != undefined && value != '') {
        throw this.createError({ message: 'Invalid data. \'End km (Direction B)\' must be a number' });
      }
      return true;
    }),
  status: Yup.string("status").nullable(true),
  remarks: Yup.string("remarks").nullable(true),
  //Infrastructure Rules:
  roadsNpmInfraDTO: Yup.object().shape({
    category: Yup.string('Value should be a text').nullable(true),
    pavementCondition: Yup.string('Value should be a text').nullable(true),
    lanesDirectionA: Yup.number()
      .typeError(createNumberValidation('Number of Lanes - Direction A (no.)'))
      .nullable(true),
    lanesDirectionB: Yup.number()
      .typeError("Invalid data. 'Number of Lanes - Direction B (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Number of Lanes - Direction B (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Number of Lanes - Direction B (no.)\' must be a number' });
        }
        return true;
      }),
    lengthTotalDirA: Yup.number()
      .typeError(createNumberValidation('Total Length - Direction A (km)'))
      .nullable(true),
    lengthTotalDirB: Yup.number()
      .typeError("Invalid data. 'Total Length - Direction B (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Total Length - Direction B (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Total Length - Direction B (km)\' must be a number' });
        }
        return true;
      }),
    lengthOpenRoadDirA: Yup.number()
      .typeError(createNumberValidation('Length of Open Road - Direction A (km)'))
      .nullable(true)
      .test('length-check', 'Length should not be longer than the Total Length', function (value) {
        const totalLength = this.resolve(Yup.ref('lengthTotalDirA'));
        if (value > totalLength) {
          throw this.createError({ message: 'Length should not be longer than the Total Length' });
        }
        return true;
      }),
    lengthOpenRoadDirB: Yup.number()
      .typeError("Invalid data. 'Length of Open Road - Direction B (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Length of Open Road - Direction B (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Length of Open Road - Direction B (km)\' must be a number' });
        }
        return true;
      }),
    lengthTunnelsDirA: Yup.number()
      .typeError(createNumberValidation('Length of Tunnel - Direction A (km)'))
      .nullable(true)
      .test('length-check', 'Length should not be longer than the Total Length', function (value) {
        const totalLength = this.resolve(Yup.ref('lengthTotalDirA'));
        if (value > totalLength) {
          throw this.createError({ message: 'Length should not be longer than the Total Length' });
        }
        return true;
      }),
    lengthTunnelsDirB: Yup.number()
      .typeError("Invalid data. 'Length of Tunnel - Direction B (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Length of Tunnel - Direction B (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Length of Tunnel - Direction B (km)\' must be a number' });
        }
        return true;
      }),
    lengthBridgesDirA: Yup.number()
      .typeError(createNumberValidation('Length of Bridges – Direction A (km)'))
      .nullable(true)
      .test('length-check', 'Length should not be longer than the Total Length', function (value) {
        const totalLength = this.resolve(Yup.ref('lengthTotalDirA'));
        if (value > totalLength) {
          throw this.createError({ message: 'Length should not be longer than the Total Length' });
        }
        return true;
      }),
    lengthBridgesDirB: Yup.number()
      .typeError("Invalid data. 'Length of Bridges – Direction B (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Length of Bridges – Direction B (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Length of Bridges – Direction B (km)\' must be a number' });
        }
        return true;
      }),
    tunnelsDirA: Yup.number()
      .typeError("Invalid data. 'Tunnels – Direction A (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Tunnels – Direction A (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Tunnels – Direction A (no.)\' must be a number' });
        }
        return true;
      }),
    tunnelsDirB: Yup.number()
      .typeError("Invalid data. 'Tunnels – Direction B (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Tunnels – Direction B (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Tunnels – Direction B (no.)\' must be a number' });
        }
        return true;
      }),
    parkingAreasDirA: Yup.number()
      .typeError("Invalid data. 'Parking Areas – Direction A (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Parking Areas – Direction A (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Parking Areas – Direction A (no.)\' must be a number' });
        }
        return true;
      }),
    parkingAreasDirB: Yup.number()
      .typeError("Invalid data. 'Parking Areas – Direction B (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Parking Areas – Direction A (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Parking Areas – Direction A (no.)\' must be a number' });
        }
        return true;
      }),
    fuelStationsDirA: Yup.number()
      .typeError("Invalid data. 'Fuel Stations – Direction A (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Fuel Stations – Direction A (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Fuel Stations – Direction A (no.)\' must be a number' });
        }
        return true;
      }),
    fuelStationsDirB: Yup.number()
      .typeError("Invalid data. 'Fuel Stations – Direction B (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Fuel Stations – Direction B (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Fuel Stations – Direction B (no.)\' must be a number' });
        }
        return true;
      }),
    /*     fuelTypeDirA: Yup.string('Value should be a text').nullable(true),
        fuelTypeDirB: Yup.string('Value should be a text').nullable(true), */
    designSpeed: Yup.number()
      .typeError("Invalid data. 'Design Speed (km/h)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Design Speed (km/h)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Design Speed (km/h)\' must be a number' });
        }
        return true;
      }),
    speedLimit: Yup.number()
      .typeError("Invalid data. 'Speed Limit (km/h)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Speed Limit (km/h)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Speed Limit (km/h)\' must be a number' });
        }
        return true;
      }),
    operatingSpeed: Yup.number()
      .typeError("Invalid data. 'Speed Limit (km/h)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Speed Limit (km/h)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Speed Limit (km/h)\' must be a number' });
        }
        return true;
      }),
    tolled: Yup.boolean().nullable(true),
    tollsType: Yup.string('Value should be a text').nullable(true),
    tollsChargingMethod: Yup.string('Value should be a text').nullable(true),
    tollLanesManned: Yup.number()
      .typeError("Invalid data. 'No. of toll station lanes (manned)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'No. of toll station lanes (manned)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'No. of toll station lanes (manned)\' must be a number' });
        }
        return true;
      }),
    tollLanesElectronic: Yup.number()
      .typeError("Invalid data. 'No. of toll station lanes (electronic)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'No. of toll station lanes (electronic)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'No. of toll station lanes (elecetronic)\' must be a number' });
        }
        return true;
      }),
    its: Yup.boolean().nullable(true),
    itsType: Yup.string('Value should be a text').nullable(true),
    supervisedControlCenter: Yup.boolean().nullable(true),
    separationRoadCarriageways: Yup.boolean().nullable(true),
    noCrossingsAtGrade: Yup.boolean().nullable(true),
    detectProvideSafetyTrafficInformation: Yup.boolean().nullable(true),
    remarks: Yup.string("remarks").nullable(true)
  }),
  //Operations
  roadsNpmOpsDTO: Yup.object().shape({
    totalTrafficFlowAadt: Yup.number()
      .typeError("Invalid data. 'Total traffic flow (AADT)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Total traffic flow (AADT)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Total traffic flow (AADT)\' must be a number' });
        }
        return true;
      }),
    passengerCarsAadt: Yup.number()
      .typeError("Invalid data. 'Passenger cars (AADT)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Passenger cars (AADT)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Passenger cars (AADT)\' must be a number' });
        }
        return true;
      }),
    bussesAadt: Yup.number()
      .typeError("Invalid data. 'Buses (AADT)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Buses (AADT)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Buses (AADT)\' must be a number' });
        }
        return true;
      }),
    trucksAadt: Yup.number()
      .typeError("Invalid data. 'Trucks (AADT)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Trucks (AADT)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Trucks (AADT)\' must be a number' });
        }
        return true;
      }),
    internationalTrafficPerAadt: Yup.number()
      .typeError("Invalid data. 'International traffic (% of total traffic flow)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'International traffic (% of total traffic flow)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'International traffic (% of total traffic flow)\' must be a number' });
        }
        return true;
      }),
    hgvsPerAadt: Yup.number()
      .typeError("Invalid data. 'Heavy Good Vehicles (% of total traffic flow)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Heavy Good Vehicles (% of total traffic flow)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Heavy Good Vehicles (% of total traffic flow)\' must be a number' });
        }
        return true;
      }),
    freightTrafficTonsPy: Yup.number()
      .typeError("Invalid data. 'Freight traffic flow (tonnes per year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Freight traffic flow (tonnes per year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Freight traffic flow (tonnes per year)\' must be a number' });
        }
        return true;
      }),
    freightTrafficVehPy: Yup.number()
      .typeError("Invalid data. 'Freight traffic flow (vehicles per year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Freight traffic flow (vehicles per year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Freight traffic flow (vehicles per year)\' must be a number' });
        }
        return true;
      }),
    dangerousGoodsVehPerAadt: Yup.number()
      .typeError("Invalid data. 'Dangerous goods vehicles (no/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Dangerous goods vehicles (no/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Dangerous goods vehicles (no/year)\' must be a number' });
        }
        return true;
      }),
    passengers: Yup.number()
      .typeError("Invalid data. 'Passengers (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Passengers (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Passengers (no.)\' must be a number' });
        }
        return true;
      }),
    aveTravelTimePcs: Yup.number()
      .typeError("Invalid data. 'Average travel time Passenger Cars (hours)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Average travel time Passenger Cars (hours)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Average travel time Passenger Cars (hours)\' must be a number' });
        }
        return true;
      }),
    aveTravelTimeHvgs: Yup.number()
      .typeError("Invalid data. 'Average travel time HGVs (hours)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Average travel time HGVs (hours)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Average travel time HGVs (hours)\' must be a number' });
        }
        return true;
      }),
    tollRateCurr: Yup.string('Value should be string').nullable(true),
    tollRatePassCarsPkm: Yup.number()
      .typeError("Invalid data. 'Toll rate currency' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Toll rate currency\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Toll rate currency\' must be a number' });
        }
        return true;
      }),
    tollRatePassCarsPday: Yup.number()
      .typeError("Invalid data. 'Toll Rate Passenger Cars (per day)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Toll Rate Passenger Cars (per day)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Toll Rate Passenger Cars (per day)\' must be a number' });
        }
        return true;
      }),
    tollRateHgVehPkm: Yup.number()
      .typeError("Invalid data. 'Toll Rate Passenger Cars (per km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Toll Rate Heavy Good Vehicles (per km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Toll Rate Heavy Good Vehicles (per km)\' must be a number' });
        }
        return true;
      }),
    tollRateHgVehPday: Yup.number()
      .typeError("Invalid data. 'Toll Rate Heavy Good Vehicles (per day)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Toll Rate Heavy Good Vehicles (per day)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Toll Rate Heavy Good Vehicles (per day)\' must be a number' });
        }
        return true;
      }),
    perTollEvation: Yup.number()
      .typeError("Invalid data. 'Toll evasion (%)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Toll evasion (%)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Toll evasion (%)\' must be a number' });
        }
        return true;
      }),
    remarks: Yup.string("remarks").nullable(true)
  }),
  //TENT COMP
  roadsNpmTentcompDTO: Yup.object().shape({
    tentReqComp: Yup.boolean().nullable(true),
    altFuelAval: Yup.boolean().nullable(true),
    itsComp: Yup.string().nullable(true),
    tollInterop: Yup.string().nullable(true),
    safetyComp: Yup.boolean().nullable(true),
    roadTunnelComp: Yup.string().nullable(true),
    remarks: Yup.string("remarks").nullable(true),
    separationRoadCarriageways: Yup.string().nullable(true),
    noCrossingsAtGrade: Yup.string().nullable(true),
    restAreasAvailability: Yup.string().nullable(true),
    safeParkingAvailability: Yup.string().nullable(true),
    weighInMotionSystems: Yup.string().nullable(true),
    detectProvideSafetyTrafficInformation: Yup.string().nullable(true),
    alternativeFuelsElectricityLight: Yup.string().nullable(true),
    alternativeFuelsElectricityHeavy: Yup.string().nullable(true),
    alternativeFuelsHydrogen: Yup.string().nullable(true),
    alternativeFuelsLiquifiedMethane: Yup.string().nullable(true)
  }),
  //Safety
  roadsNpmSafetyDTO: Yup.object().shape({
    totalTrafficCrash: Yup.number()
      .typeError("Invalid data. 'Total number of road traffic crash (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Total number of road traffic crash (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Total number of road traffic crash (no.)\' must be a number' });
        }
        return true;
      }),
    totalTrafficSerInj: Yup.number()
      .typeError("Invalid data. 'Road traffic crash with serious injuries only (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Road traffic crash with serious injuries only (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Road traffic crash with serious injuries only (no.)\' must be a number' });
        }
        return true;
      }),
    fataTrafficCrash: Yup.number()
      .typeError("Invalid data. 'Fatal road traffic crash (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Fatal road traffic crash (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Fatal road traffic crash (no.)\' must be a number' });
        }
        return true;
      }),
    /* chainageTrafficCrash : Yup.number()
    .typeError("Invalid data. 'chainageTrafficCrash' must be a 'number'")
    .nullable(true)
    .test('is-number', 'Invalid data. \'chainageTrafficCrash\' must be a number', function (value) {
      if (isNaN(value) && value != null && value != undefined && value != '') {
        throw this.createError({ message: 'Invalid data. \'chainageTrafficCrash\' must be a number' });
      }
      return true;
    }), */
    totalInj: Yup.number()
      .typeError("Invalid data. 'Total injured (no. of persons)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Total injured (no. of persons)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Total injured (no. of persons)\' must be a number' });
        }
        return true;
      }),
    serInj: Yup.number()
      .typeError("Invalid data. 'Seriously injured (no. of persons)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Seriously injured (no. of persons)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Seriously injured (no. of persons)\' must be a number' });
        }
        return true;
      }),
    fatalities: Yup.number()
      .typeError("Invalid data. 'Fatalities (no. of persons)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Fatalities (no. of persons)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Fatalities (no. of persons)\' must be a number' });
        }
        return true;
      }),
    roadSafetyAudit: Yup.boolean().nullable(true),
    rankedHighRisk: Yup.boolean().nullable(true),
    roadSafetyInsp: Yup.number()
      .typeError("Invalid data. 'Road safety inspections performed' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Road safety inspections performed\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Road safety inspections performed\' must be a number' });
        }
        return true;
      }),
    remarks: Yup.string("remarks").nullable(true)
  }),
  //Maintenance
  roadsNpmMaintDTO: Yup.object().shape({
    maintCostTotal: Yup.number()
      .typeError("Invalid data. 'Maintenance cost - total (Euro/km/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Maintenance cost - total (Euro/km/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Maintenance cost - total (Euro/km/year)\' must be a number' });
        }
        return true;
      }),
    maintCostOpenRoads: Yup.number()
      .typeError("Invalid data. 'Maintenance cost – open road (Euro/km/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Maintenance cost – open road (Euro/km/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Maintenance cost – open road (Euro/km/year)\' must be a number' });
        }
        return true;
      }),
    maintCostTunnels: Yup.number()
      .typeError("Invalid data. 'Maintenance cost – tunnels (Euro/km/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Maintenance cost – tunnels (Euro/km/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Maintenance cost – tunnels (Euro/km/year)\' must be a number' });
        }
        return true;
      }),
    maintCostBridges: Yup.number()
      .typeError("Invalid data. 'Maintenance cost – bridges (Euro/km/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Maintenance cost – bridges (Euro/km/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Maintenance cost – bridges (Euro/km/year)\' must be a number' });
        }
        return true;
      }),
    hpMaintCost: Yup.number()
      .typeError("Invalid data. 'Heavy/Periodic maintenance cost (Euro/km/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Heavy/Periodic maintenance cost (Euro/km/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Heavy/Periodic maintenance cost (Euro/km/year)\' must be a number' });
        }
        return true;
      }),
    emerMaintCost: Yup.number()
      .typeError("Invalid data. 'Emergency maintenance cost (Euro/km/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Emergency maintenance cost (Euro/km/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Emergency maintenance cost (Euro/km/year)\' must be a number' });
        }
        return true;
      }),
    winterMaintCost: Yup.number()
      .typeError("Invalid data. 'Winter maintenance cost (Euro/km/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Winter maintenance cost (Euro/km/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Winter maintenance cost (Euro/km/year)\' must be a number' });
        }
        return true;
      }),
    routineMaintCost: Yup.number()
      .typeError("Invalid data. 'Routine maintenance cost (Europ/km/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Routine maintenance cost (Europ/km/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Routine maintenance cost (Europ/km/year)\' must be a number' });
        }
        return true;
      }),
    financeSource: Yup.string('Value should be a text').nullable(true),
    reqRehabOpenRoads: Yup.number()
      .typeError("Invalid data. 'Requiring rehabilitation - Open Road (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Requiring rehabilitation - Open Road (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Requiring rehabilitation - Open Road (km)\' must be a number' });
        }
        return true;
      }),
    reqRehabTunnels: Yup.number()
      .typeError("Invalid data. 'Requiring rehabilitation - Tunnels (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Requiring rehabilitation - Tunnels (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Requiring rehabilitation - Tunnels (km)\' must be a number' });
        }
        return true;
      }),
    reqRehabBridges: Yup.number()
      .typeError("Invalid data. 'Requiring rehabilitation - Bridges (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Requiring rehabilitation - Bridges (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Requiring rehabilitation - Bridges (km)\' must be a number' });
        }
        return true;
      }),
    reqHpMaintOpenRoads: Yup.number()
      .typeError("Invalid data. 'Requiring heavy/periodic maintenance - Open Road (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Requiring heavy/periodic maintenance - Open Road (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Requiring heavy/periodic maintenance - Open Road (km)\' must be a number' });
        }
        return true;
      }),
    reqHpMaintTunnels: Yup.number()
      .typeError("Invalid data. 'Requiring heavy/periodic maintenance – Tunnel (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Requiring heavy/periodic maintenance – Tunnel (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Requiring heavy/periodic maintenance – Tunnel (km)\' must be a number' });
        }
        return true;
      }),
    reqHpMaintBridges: Yup.number()
      .typeError("Invalid data. 'Requiring heavy/periodic maintenance – Bridges (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Requiring heavy/periodic maintenance – Bridges (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Requiring heavy/periodic maintenance – Bridges (km)\' must be a number' });
        }
        return true;
      }),
    reqUpgradeOpenRoads: Yup.number()
      .typeError("Invalid data. 'Requiring upgrade to increase capacity - Open Road (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Requiring upgrade to increase capacity - Open Road (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Requiring upgrade to increase capacity - Open Road (km)\' must be a number' });
        }
        return true;
      }),
    reqUpgradeTunnels: Yup.number()
      .typeError("Invalid data. 'Requiring upgrade to increase capacity – Tunnel (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Requiring upgrade to increase capacity – Tunnel (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Requiring upgrade to increase capacity – Tunnel (km)\' must be a number' });
        }
        return true;
      }),
    reqUpgradeBridges: Yup.number()
      .typeError("Invalid data. 'Requiring upgrade to increase capacity – Bridges (km)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Requiring upgrade to increase capacity – Bridges (km)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Requiring upgrade to increase capacity – Bridges (km)\' must be a number' });
        }
        return true;
      }),
    remarks: Yup.string("remarks").nullable(true)
  }),
  //Environment
  roadsNpmEnvDTO: Yup.object().shape({
    /* airPollutGhgTpy : Yup.number()
    .typeError("Invalid data. 'Requiring upgrade to increase capacity – Bridges (km)' must be a 'number'")
    .nullable(true)
    .test('is-number', 'Invalid data. \'Requiring upgrade to increase capacity – Bridges (km)\' must be a number', function (value) {
      if (isNaN(value) && value != null && value != undefined && value != '') {
        throw this.createError({ message: 'Invalid data. \'Requiring upgrade to increase capacity – Bridges (km)\' must be a number' });
      }
      return true;
    }), */
    co2Ems: Yup.number()
      .typeError("Invalid data. 'CO2 emissions (tonnes/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'CO2 emissions (tonnes/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'CO2 emissions (tonnes/year)\' must be a number' });
        }
        return true;
      }),
    noxEms: Yup.number()
      .typeError("Invalid data. 'NOx emissions (tonnes/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'NOx emissions (tonnes/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'NOx emissions (tonnes/year)\' must be a number' });
        }
        return true;
      }),
    so2Ems: Yup.number()
      .typeError("Invalid data. 'SO2 emissions (tonnes/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'SO2 emissions (tonnes/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'SO2 emissions (tonnes/year)\' must be a number' });
        }
        return true;
      }),
    nmhcEms: Yup.number()
      .typeError("Invalid data. 'Non-methane hydrocarbons (tonnes/year)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Non-methane hydrocarbons (tonnes/year)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Non-methane hydrocarbons (tonnes/year)\' must be a number' });
        }
        return true;
      }),
    ppm: Yup.number()
      .typeError("Invalid data. 'Particulate matter (ppm)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Particulate matter (ppm)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Particulate matter (ppm)\' must be a number' });
        }
        return true;
      }),
    noise: Yup.number()
      .typeError("Invalid data. 'Noise (dB)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Noise (dB)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Noise (dB)\' must be a number' });
        }
        return true;
      }),
    chFloodInci: Yup.number()
      .typeError("Invalid data. 'Flooding incidents (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Flooding incidents (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Flooding incidents (no.)\' must be a number' });
        }
        return true;
      }),
    chClosureAdvWeatherCond: Yup.number()
      .typeError("Invalid data. 'Closures due to adverse weather conditions (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Closures due to adverse weather conditions (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Closures due to adverse weather conditions (no.)\' must be a number' });
        }
        return true;
      }),
    chEmbankFail: Yup.number()
      .typeError("Invalid data. 'Embankment failures (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Embankment failures (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Embankment failures (no.)\' must be a number' });
        }
        return true;
      }),
    chWinterMaintDays: Yup.number()
      .typeError("Invalid data. 'Winter maintenance days (no.)' must be a 'number'")
      .nullable(true)
      .test('is-number', 'Invalid data. \'Winter maintenance days (no.)\' must be a number', function (value) {
        if (isNaN(value) && value != null && value != undefined && value != '') {
          throw this.createError({ message: 'Invalid data. \'Winter maintenance days (no.)\' must be a number' });
        }
        return true;
      }),
    remarks: Yup.string("remarks").nullable(true)
  }),
  //Climate resilience
  roadsNpmClimateDTO: Yup.object().shape({
    climateEvents: Yup.array().of(
      Yup.object().shape({
        eventType: Yup.string()
          .required("Event type is required")
          .oneOf(["Flood", "Landslide", "Sea surge", "High temperature", "Snowdrift"], "Invalid event type"),
        startPointLat: Yup.number()
          .typeError("Invalid data. 'Start Point Latitude' must be a number")
          .nullable(true)
          .min(-90, "Latitude must be between -90 and 90")
          .max(90, "Latitude must be between -90 and 90"),
        startPointLon: Yup.number()
          .typeError("Invalid data. 'Start Point Longitude' must be a number")
          .nullable(true)
          .min(-180, "Longitude must be between -180 and 180")
          .max(180, "Longitude must be between -180 and 180"),
        endPointLat: Yup.number()
          .typeError("Invalid data. 'End Point Latitude' must be a number")
          .nullable(true)
          .min(-90, "Latitude must be between -90 and 90")
          .max(90, "Latitude must be between -90 and 90"),
        endPointLon: Yup.number()
          .typeError("Invalid data. 'End Point Longitude' must be a number")
          .nullable(true)
          .min(-180, "Longitude must be between -180 and 180")
          .max(180, "Longitude must be between -180 and 180"),
        disruptionStartDate: Yup.date()
          .nullable(true)
          .typeError("Invalid data. Disruption start date must be a valid date"),
        disruptionEndDate: Yup.date()
          .nullable(true)
          .typeError("Invalid data. Disruption end date must be a valid date")
          .min(
            Yup.ref('disruptionStartDate'),
            "Disruption end date must be after start date"
          )
      })
    ).nullable(true)
  }),
});




const NP_INIT = {
  //general section Rules:
  // general_road_id: "",
  startKm: "",
  endKm: "",
  /*   dateValidTo: "",
    dateValidFrom: "", */
  dateValidFor: "",
  tenTCategory: "",
  routeId: "",
  nationalRouteId: "",
  internationalRouteId: "",
  startNodeName: "",
  endNodeName: "",
  nameResp: "",
  addressResp: "",
  contactPer: "",
  contactPos: "",
  contactNum: 0,
  contactEmail: "",
  startKmDirA: "",
  startKmDirB: "",
  endKmDirA: "",
  endKmDirB: "",
  regionalPartner: "",
  status: "",
  remarks: "",
  roadsNpmEnvDTO: {
    airPollutGhgTpy: "",
    co2Ems: "",
    noxEms: "",
    so2Ems: "",
    nmhcEms: "",
    ppm: "",
    noise: "",
    chFloodInci: "",
    chClosureAdvWeatherCond: "",
    chEmbankFail: "",
    chWinterMaintDays: "",
    remarks: ""
  },
  roadsNpmInfraDTO: {
    category: "",
    pavementCondition: "",
    lanesDirectionA: "",
    lanesDirectionB: "",
    lengthTotalDirA: "",
    lengthTotalDirB: "",
    lengthOpenRoadDirA: "",
    lengthOpenRoadDirB: "",
    lengthTunnelsDirA: "",
    lengthTunnelsDirB: "",
    lengthBridgesDirA: "",
    lengthBridgesDirB: "",
    tunnelsDirA: "",
    tunnelsDirB: "",
    parkingAreasDirA: "",
    parkingAreasDirB: "",
    fuelStationsDirA: "",
    fuelStationsDirB: "",
    fuelTypeDirA: "",
    fuelTypeDirB: "",
    designSpeed: "",
    speedLimit: "",
    operatingSpeed: "",
    lengthThroughLocalityDirA: "",
    lengthThroughLocalityDirB: "",
    maxLongitudinalGradientDirA: "",
    maxLongitudinalGradientDirB: "",
    maxPermitWeightPerVehicle: "",
    maxPermitWeightAxleLoad: "",
    capacityPcuDirA: "",
    capacityPcuDirB: "",
    tolled: false,
    tollsType: "",
    tollsChargingMethod: "",
    tollLanesManned: "",
    tollLanesElectronic: "",
    its: false,
    itsType: "",
    supervisedControlCenter: false,
    separationRoadCarriageways: false,
    noCrossingsAtGrade: false,
    detectProvideSafetyTrafficInformation: false,
    remarks: ""
  },
  roadsNpmOpsDTO: {
    totalTrafficFlowAadt: "",
    passengerCarsAadt: "",
    bussesAadt: "",
    trucksAadt: "",
    internationalTrafficPerAadt: "",
    hgvsPerAadt: "",
    freightTrafficTonsPy: "",
    freightTrafficVehPy: "",
    dangerousGoodsVehPerAadt: "",
    passengers: "",
    aveTravelTimePcs: "",
    aveTravelTimeHvgs: "",
    tollRateCurr: "",
    tollRatePassCarsPkm: "",
    tollRatePassCarsPday: "",
    tollRateHgVehPkm: "",
    tollRateHgVehPday: "",
    perTollEvation: "",
    remarks: ""
  },
  roadsNpmTentcompDTO: {
    tentReqComp: "",
    altFuelAval: false,
    itsComp: "",
    tollInterop: false,
    safetyComp: false,
    roadTunnelComp: false,
    remarks: "",
    separationRoadCarriageways: "",
    noCrossingsAtGrade: "",
    restAreasAvailability: "",
    safeParkingAvailability: "",
    weighInMotionSystems: "",
    detectProvideSafetyTrafficInformation: "",
    alternativeFuelsElectricityLight: "",
    alternativeFuelsElectricityHeavy: "",
    alternativeFuelsHydrogen: "",
    alternativeFuelsLiquifiedMethane: ""
  },

  roadsNpmSafetyDTO: {
    totalTrafficCrash: "",
    totalTrafficSerInj: "",
    fataTrafficCrash: "",
    chainageTrafficCrash: "",
    totalInj: "",
    serInj: "",
    fatalities: "",
    roadSafetyAudit: false,
    rankedHighRisk: false,
    roadSafetyInsp: false,
    remarks: ""
  },

  roadsNpmMaintDTO: {
    maintCostTotal: "",
    maintCostOpenRoads: "",
    maintCostTunnels: "",
    maintCostBridges: "",
    hpMaintCost: "",
    emerMaintCost: "",
    winterMaintCost: "",
    routineMaintCost: "",
    financeSource: "",
    reqRehabOpenRoads: "",
    reqRehabTunnels: "",
    reqRehabBridges: "",
    reqHpMaintOpenRoads: "",
    reqHpMaintTunnels: "",
    reqHpMaintBridges: "",
    reqUpgradeOpenRoads: "",
    reqUpgradeTunnels: "",
    reqUpgradeBridges: "",
    remarks: "",
  },

  roadsNpmClimateDTO: {
    climateEvents: []
  }
}
const NP_INIT_DEMO = {
  //general section Rules:
  general_road_id: "RD-111",
  startKm: 20 + " KM",
  endKm: 100 + " KM",
  dateValidTo: "2012-01-01",
  dateValidFrom: "2012-01-01",
  tenTCategory: "Core",
  routeId: "RD-11",
  nationalRouteId: "K-122",
  internationalRouteId: "K-122",
  startNodeName: "Node Name",
  general_endnode_name: "Node Name",
  general_status: "Planned",
  general_org_name: "Org Name",
  general_org_address: "Spain, Madrid",
  contactPer: "John Doe",
  contactPos: "Ex. GIS Consultant",
  contactNum: 38112345678,
  contactEmail: "John.Doe@Org.Com",
  startKmDirA: "25",
  startKmDirB: "52",
  endKmDirA: "52",
  endKmDirB: "52",
  countryCode: "52",

  //Infrastructure Rules:
  "roadsNpmInfraDTO.category": "",
  "roadsNpmInfraDTO.pavementCondition": "",
  "roadsNpmInfraDTO.lanesDirectionA": "",
  "roadsNpmInfraDTO.lanesDirectionB": "",
  "roadsNpmInfraDTO.lengthTotalDirA": "",
  "roadsNpmInfraDTO.lengthTotalDirB": "",
  "roadsNpmInfraDTO.lengthOpenRoadDirA": "",
  "roadsNpmInfraDTO.lengthOpenRoadDirB": "",
  "roadsNpmInfraDTO.lengthTunnelsDirA": "",
  "roadsNpmInfraDTO.lengthTunnelsDirB": "",
  "roadsNpmInfraDTO.lengthBridgesDirA": "",
  "roadsNpmInfraDTO.lengthBridgesDirB": "",
  "roadsNpmInfraDTO.tunnelsDirA": "",
  "roadsNpmInfraDTO.tunnelsDirB": "",
  "roadsNpmInfraDTO.parkingAreasDirA": "",
  "roadsNpmInfraDTO.parkingAreasDirB": "",
  "roadsNpmInfraDTO.fuelStationsDirA": "",
  "roadsNpmInfraDTO.fuelStationsDirB": "",
  "roadsNpmInfraDTO.fuelTypeDirA": "",
  "roadsNpmInfraDTO.fuelTypeDirB": "",
  "roadsNpmInfraDTO.designSpeed": "",
  "roadsNpmInfraDTO.speedLimit": "",
  "roadsNpmInfraDTO.operatingSpeed": "",
  "roadsNpmInfraDTO.tolled": false,
  "roadsNpmInfraDTO.tollsType": "",
  "roadsNpmInfraDTO.tollsChargingMethod": "",
  "roadsNpmInfraDTO.tollLanesManned": "",
  "roadsNpmInfraDTO.tollLanesElectronic": "",
  "roadsNpmInfraDTO.its": false,
  "roadsNpmInfraDTO.itsType": "",
  "roadsNpmInfraDTO.supervisedControlCenter": false,
  "roadsNpmInfraDTO.separationRoadCarriageways": false,
  "roadsNpmInfraDTO.noCrossingsAtGrade": false,
  "roadsNpmInfraDTO.detectProvideSafetyTrafficInformation": false,
  //Operations
  "roadsNpmOpsDTO.totalTrafficFlowAadt": "",
  "roadsNpmOpsDTO.passengerCarsAadt": "",
  "roadsNpmOpsDTO.bussesAadt": "",
  "roadsNpmOpsDTO.trucksAadt": "",
  "roadsNpmOpsDTO.internationalTrafficPerAadt": "",
  "roadsNpmOpsDTO.hgvsPerAadt": "",
  "roadsNpmOpsDTO.freightTrafficTonsPy": "",
  "roadsNpmOpsDTO.freightTrafficVehPy": "",
  "roadsNpmOpsDTO.dangerousGoodsVehPerAadt": "",
  "roadsNpmOpsDTO.passengers": "",
  "roadsNpmOpsDTO.aveTravelTimePcs": "",
  "roadsNpmOpsDTO.aveTravelTimeHvgs": "",
  "roadsNpmOpsDTO.tollRateCurr": "",
  "roadsNpmOpsDTO.tollRatePassCarsPkm": "",
  "roadsNpmOpsDTO.tollRatePassCarsPday": "",
  "roadsNpmOpsDTO.tollRateHgVehPkm": "",
  "roadsNpmOpsDTO.tollRateHgVehPday": "",
  "roadsNpmOpsDTO.perTollEvation": "",
  //TENT COMP
  "roadsNpmTentcompDTO.tentReqComp": false,
  "roadsNpmTentcompDTO.altFuelAval": false,
  "roadsNpmTentcompDTO.itsComp": false,
  "roadsNpmTentcompDTO.tollInterop": false,
  "roadsNpmTentcompDTO.safetyComp": false,
  "roadsNpmTentcompDTO.roadTunnelComp": false,
  "roadsNpmTentcompDTO.separationRoadCarriageways": "",
  "roadsNpmTentcompDTO.noCrossingsAtGrade": "",
  "roadsNpmTentcompDTO.restAreasAvailability": "",
  "roadsNpmTentcompDTO.safeParkingAvailability": "",
  "roadsNpmTentcompDTO.weighInMotionSystems": "",
  "roadsNpmTentcompDTO.detectProvideSafetyTrafficInformation": "",
  "roadsNpmTentcompDTO.alternativeFuelsElectricityLight": "",
  "roadsNpmTentcompDTO.alternativeFuelsElectricityHeavy": "",
  "roadsNpmTentcompDTO.alternativeFuelsHydrogen": "",
  "roadsNpmTentcompDTO.alternativeFuelsLiquifiedMethane": "",
  //Safety
  "roadsNpmSafetyDTO.totalTrafficCrash": "",
  "roadsNpmSafetyDTO.totalTrafficSerInj": "",
  "roadsNpmSafetyDTO.fataTrafficCrash": "",
  "roadsNpmSafetyDTO.chainageTrafficCrash": "",
  "roadsNpmSafetyDTO.totalInj": "",
  "roadsNpmSafetyDTO.serInj": "",
  "roadsNpmSafetyDTO.fatalities": "",
  "roadsNpmSafetyDTO.roadSafetyAudit": false,
  "roadsNpmSafetyDTO.rankedHighRisk": false,
  "roadsNpmSafetyDTO.roadSafetyInsp": "",
  //Maintenance
  "roadsNpmMaintDTO.maintCostTotal": "",
  "roadsNpmMaintDTO.maintCostOpenRoads": "",
  "roadsNpmMaintDTO.maintCostTunnels": "",
  "roadsNpmMaintDTO.maintCostBridges": "",
  "roadsNpmMaintDTO.hpMaintCost": "",
  "roadsNpmMaintDTO.emerMaintCost": "",
  "roadsNpmMaintDTO.winterMaintCost": "",
  "roadsNpmMaintDTO.routineMaintCost": "",
  "roadsNpmMaintDTO.financeSource": "",
  "roadsNpmMaintDTO.reqRehabOpenRoads": "",
  "roadsNpmMaintDTO.reqRehabTunnels": "",
  "roadsNpmMaintDTO.reqRehabBridges": "",
  "roadsNpmMaintDTO.reqHpMaintOpenRoads": "",
  "roadsNpmMaintDTO.reqHpMaintTunnels": "",
  "roadsNpmMaintDTO.reqHpMaintBridges": "",
  "roadsNpmMaintDTO.reqUpgradeOpenRoads": "",
  "roadsNpmMaintDTO.reqUpgradeTunnels": "",
  "roadsNpmMaintDTO.reqUpgradeBridges": "",
  //Environment
  "roadsNpmEnvDTO.airPollutGhgTpy": "",
  "roadsNpmEnvDTO.co2Ems": "",
  "roadsNpmEnvDTO.noxEms": "",
  "roadsNpmEnvDTO.so2Ems": "",
  "roadsNpmEnvDTO.nmhcEms": "",
  "roadsNpmEnvDTO.ppm": "",
  "roadsNpmEnvDTO.noise": "",
  "roadsNpmEnvDTO.chFloodInci": "",
  "roadsNpmEnvDTO.chClosureAdvWeatherCond": "",
  "roadsNpmEnvDTO.chEmbankFail": "",
  "roadsNpmEnvDTO.chWinterMaintDays": "",
  //Climate resilience
  "roadsNpmClimateDTO.flood": "",
  "roadsNpmClimateDTO.landslides": "",
  "roadsNpmClimateDTO.seaSurge": "",
  "roadsNpmClimateDTO.snowdrift": "",
  "roadsNpmClimateDTO.highTemperature": "",
  "roadsNpmClimateDTO.multiHazard": "",
}
const TODIS_TASK = Yup.object().shape({
  // section Rules:
  startKm: Yup.string('Value should be number').when('transportType', { is: (value) => parseInt(value) == 87 || parseInt(value) == 88 || parseInt(value) == 91, then: (rule) => rule.required("Start Node is a requerid field"), otherwise: (rule) => rule.notRequired() }),
  endKm: Yup.string('Value should be number').when('transportType', { is: (value) => parseInt(value) == 87 || parseInt(value) == 88 || parseInt(value) == 91, then: (rule) => rule.required("End Node is a requerid field"), otherwise: (rule) => rule.notRequired() }),
  description: Yup.string("open text"),
  projectType: Yup.number('Value should be a text').required('Required'),
  transportType: Yup.number('Value should be a text').required('Required').when('projectType', {
    is: (val) => parseInt(val) == 86,
    then: (rule) => rule.notRequired()
  }),
  regionalPartnar: Yup.number('Value should be a text').required('Required'),
  assignedTo: Yup.string('Value should be a text').required('Required'),
  tentCategory: Yup.number('Value should be a text').required("req").when('projectType', {
    is: (val) => parseInt(val) == 86,
    then: (rule) => rule.notRequired()
  }).when('transportType', {
    is: (val) => parseInt(val) != 87 || parseInt(val) != 88 || parseInt(val) != 91,
    then: (rule) => rule.notRequired()
  }),
  routeId: Yup.string("National Route ID is alphanumeric").required('Required').when('projectType', {
    is: (val) => parseInt(val) == 86,
    then: (rule) => rule.notRequired()
  }),
  validFrom: Yup.string().required(),
  // validTo: Yup.date().min(
  //     Yup.ref('validFrom'),
  //     "Validation from can't be before Validation to"
  //   ).required('Required')
});


const TODIS_EU_ACQUIS = Yup.object().shape({
  // section Rules:
  celexNumber: Yup.string('Alphanumeric Type').required("Required"),
  legalAct: Yup.string('open text').required("Required"),
  description: Yup.string("open text"),
  sector: Yup.string('Select from the list').required("Required"),
  regulatoryArea: Yup.string('Select from the list').required("Required"),
  typeOfAct: Yup.string('Select from the list').required("Required"),
  actionPlan: Yup.string('Select from the list').required("Required"),
  regionalPartnar: Yup.array().min(1, "Choose at least 1 Regional Partner").required("Role is required"),
  // assignedTo: Yup.string('Value should be a text').required('Required'),
  validFrom: Yup.string().required(),
});

const TODIS_RW_MARKET_MON = Yup.object().shape({
  regionalPartnar: Yup.array().min(1, "Choose at least 1 Regional Partner").required("Role is required"),
  validFrom: Yup.string().required(),
});


const TASK = {
  startKm: "",
  endKm: "",
  projectType: "",
  transportType: 0,
  regionalPartnar: "",
  assignedTo: "",
  tentCategory: 4,
  routeId: "",
  description: "",
  validFrom: new Date().getFullYear(),
  // validTo: ""
}

const EU_ACQUIS = {
  regionalPartnar: "",
  celexNumber: "",
  legalAct: "",
  sector: "",
  regulatoryArea: "",
  typeOfAct: "",
  actionPlan: "",
  validFrom: new Date().getFullYear(),
  // assignedTo: "",
  description: "",

}

const RW_MARKET_MON = {
  regionalPartnar: "",
  validFrom: new Date().getFullYear(),
  description:"",
}

const TODIS_UPD_REQUEST = Yup.object().shape({
  assignedTo: Yup.string('Value should be a text').required('Required'),
  validOf: Yup.string().required('Required')
});

const UPD_REQUEST = {
  requestIds: [],
  assignedTo: "",
  validOf: new Date().getFullYear()
}

const TODIS_COMMENT = Yup.object().shape({
  comment: Yup.string().required('Required')
});

export { RW_MARKET_MON, TODIS_RW_MARKET_MON, TODIS_NP_SCHEMA, NP_INIT, TODIS_TASK, TASK, NP_INIT_DEMO, TODIS_UPD_REQUEST, UPD_REQUEST, TODIS_COMMENT, EU_ACQUIS, TODIS_EU_ACQUIS };